import {omneticApi} from '@dms/api/base';

import {
  GetVehicleSelectionAttributesApiResponse,
  GetVehicleSelectionAttributesApiResponseSchema,
  PreviewPromotionalPhotoVehicleSelectionApiArg,
  PreviewPromotionalPhotoVehicleSelectionApiResponse,
  VehicleSelectionPreviewResponseBodySchema,
} from './types';

export const vehicleSelectionApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getVehicleSelectionAttributes: build.query<GetVehicleSelectionAttributesApiResponse, void>({
      query: () => ({
        url: `/dms/v1/vehicle-selection/attributes`,
      }),
      extraOptions: {
        responseSchema: GetVehicleSelectionAttributesApiResponseSchema,
      },
    }),
    // A mutation rather than a query: computed on demand from the whole draft in the body and never
    // re-fetched automatically (same as the financing promo preview). It changes nothing on the BE.
    previewPromotionalPhotoVehicleSelection: build.mutation<
      PreviewPromotionalPhotoVehicleSelectionApiResponse,
      PreviewPromotionalPhotoVehicleSelectionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/promotional-photo/vehicle-selection/preview`,
        method: 'POST',
        body: queryArg.previewPromotionalPhotoVehicleSelectionRequestBody,
      }),
      extraOptions: {
        responseSchema: VehicleSelectionPreviewResponseBodySchema,
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetVehicleSelectionAttributesQuery,
  usePreviewPromotionalPhotoVehicleSelectionMutation,
} = vehicleSelectionApi;
